import { render } from "./GameMatePrivacyPolicy.vue?vue&type=template&id=31b1cc9a&scoped=true"
const script = {}

import "./GameMatePrivacyPolicy.vue?vue&type=style&index=0&id=31b1cc9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b1cc9a"]])

export default __exports__